// extracted by mini-css-extract-plugin
export default {"toastContainer":"customToast_toastContainer__XO218"};